class StoreLocatorSlider {
  constructor(sectionId) {
    this.section = document.getElementById(sectionId);
    if (!this.section) return;
    
    this.initialized = false;
    this.swiper = null;
    this.observer = null;
    
    // Initialize when section becomes visible
    this.initIntersectionObserver();
  }
  
  initIntersectionObserver() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.initialized) {
            this.loadDependencies().then(() => this.init());
          }
        });
      }, { rootMargin: '200px' });
      
      this.observer.observe(this.section);
    } else {
      // Fallback for browsers without IntersectionObserver
      this.loadDependencies().then(() => this.init());
    }
  }
  
  loadDependencies() {
    return new Promise((resolve) => {
      window.whenSwiperReady(resolve);
    });
  }
  
  init() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Initialize Swiper
    this.initSwiper();
    
    // Set up event listeners
    this.setupEventListeners();
    
    // Initialize first store
    const firstStore = this.section.querySelector('.store-thumbnail');
    if (firstStore) {
      this.updateStore(firstStore.dataset.store);
    }
  }
  
  initSwiper() {
    this.swiper = new Swiper('.store-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 15,
      centeredSlides: true,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      },
      on: {
        slideChange: () => {
          const activeSlide = this.swiper.slides[this.swiper.activeIndex];
          const thumbnail = activeSlide.querySelector('.store-thumbnail');
          if (thumbnail) {
            this.updateStore(thumbnail.dataset.store);
          }
        }
      }
    });
  }
  
  setupEventListeners() {
    // Handle thumbnail clicks
    this.section.addEventListener('click', (e) => {
      const thumbnail = e.target.closest('.store-thumbnail');
      const mobileTab = e.target.closest('.store-mobile-tab');
      
      
      if (thumbnail) {
        e.preventDefault();
        this.updateStore(thumbnail.dataset.store);
        
        // Update Swiper to show the clicked slide
        const slideIndex = Array.from(thumbnail.closest('.swiper-wrapper').children).indexOf(thumbnail.closest('.swiper-slide'));
        if (slideIndex !== -1) {
          this.swiper.slideTo(slideIndex);
        }
      } else if (mobileTab) {
        e.preventDefault();
        this.updateStore(mobileTab.dataset.store);
      }
    });
  }
  
  updateStore(storeId) {
    if (!storeId) return;
    
    // Update active thumbnail
    this.section.querySelectorAll('.store-thumbnail').forEach(thumb => {
      thumb.classList.toggle('active', thumb.dataset.store === storeId);
    });
    
    // Update mobile tabs
    this.section.querySelectorAll('.store-mobile-tab').forEach(tab => {
      tab.classList.toggle('active', tab.dataset.store === storeId);
    });
    
    // Update store details
    this.section.querySelectorAll('.store-locator__details').forEach(detail => {
      detail.classList.toggle('active', detail.dataset.id === storeId);
    });
    
    // Update background
    this.section.querySelectorAll('.store-locator__background').forEach(bg => {
      const isActive = bg.dataset.id === storeId;
      bg.classList.toggle('active', isActive);
      
      // Lazy load background image when it becomes active
      if (isActive && bg.classList.contains('lazyload') && bg.hasAttribute('data-bgset')) {
        bg.style.backgroundImage = `url(${bg.getAttribute('data-bgset')})`;
        bg.classList.remove('lazyload');
      }
    });
  }
}

// Initialize Store Locator Slider when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="StoreLocator-"]').forEach(section => {
      new StoreLocatorSlider(section.id);
    });
  });
} else {
  document.querySelectorAll('[id^="StoreLocator-"]').forEach(section => {
    new StoreLocatorSlider(section.id);
  });
}
